import ExpertRepository from '@/shared/http/repositories/configuration/expert'
import { mutationTypes as mutation } from './mutations'
import store from '@/store/'

const MODULE_NAME = 'expert/experts'
const GET_EXPERT_BY_ID = 'getExpertById'
const GET_ALL_EXPERTS_BY_AREA = 'getAllExpertByArea'

export const actionTypes = {
  GET_EXPERT_BY_ID,
  GET_ALL_EXPERTS_BY_AREA
}

export const actions = {
  [GET_EXPERT_BY_ID] ({ commit }, payload) {
    commit(mutation.SET_EXPERT, payload)
  },

  async [GET_ALL_EXPERTS_BY_AREA] ({ commit }, mnemonic, forceReload) {
    if (store.getters[MODULE_NAME].length === 0 || (forceReload)) {
      ExpertRepository.GetAllByAreaMnemonic(mnemonic)
        .then((res) => {
          commit(mutation.SET_EXPERTS, res.data)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/expert/actions.js